import { Controller } from '@hotwired/stimulus'

// Generic controller for native <dialog> modals across the app.
//
// Wrap a trigger and a <dialog> under the same element:
//   data-controller="dialog"
//   <button data-action="dialog#open">…</button>
//   <dialog data-dialog-target="dialog" data-action="click->dialog#closeOnBackdrop">…</dialog>
//   <button data-action="dialog#close">…</button>  (inside the dialog)
//
// Escape-to-close is handled natively by showModal().
export default class extends Controller {
  static targets = ['dialog']

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close()
    }
  }
}
